import { Component, OnInit, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';

import { Customer, CustomerKeyAndName, CustomerService, TmsFormlyService } from 'tms-web-shared';
import { BaseComponent, BaseEditFormModalComponent } from '../../../../tms-shared';
import { UserCustomerService, UserService } from '../../services';
import { UserCustomer } from '../../models';

@Component({
  selector: 'app-user-customers-create-modal',
  templateUrl: './user-customers-create-modal.component.html',
  styleUrl: './user-customers-create-modal.component.scss',
  imports: [BaseEditFormModalComponent],
})
export class UserCustomersCreateModalComponent extends BaseComponent implements OnInit {
  protected readonly userCustomerService = inject(UserCustomerService);
  private readonly userService = inject(UserService);
  private readonly customerService = inject(CustomerService);
  private readonly formlyService = inject(TmsFormlyService);

  private readonly form = viewChild(BaseEditFormModalComponent);

  public readonly id = model<string>();
  public readonly model = model<UserCustomer>();
  public readonly userId = model<string>();

  protected fields: FormlyFieldConfig[];

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      ...this.formlyService.customerSearch(
        'customerSearch',
        'customerId',
        undefined,
        (model: Customer) => this.changeCustomer(model),
        () => this.clearCustomer(),
      ),
      this.formlyService.textReadonly('customerKey', $localize`Customer Account`),
      this.formlyService.textReadonly('customerName', $localize`Customer`),
    ];
  }

  private changeCustomer(model: Customer) {
    this.customerService
      .getCustomerKeyAndName(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((customer: CustomerKeyAndName) => this.form().updateModel(customer));
  }

  private clearCustomer() {
    this.form().updateModel({
      customerId: undefined,
      customerKey: undefined,
      customerName: undefined,
    });
  }

  saved() {
    this.userService.refreshDetails.next();
  }
}
